import ReorderButton from  "./ReorderButton";
export default class RecentOrderMenuCard extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        let prodTitles = "";
        return (
            <div>
                <div role="button" className="row">
                    <div role="button" className="col">
                        <div className="card fave-menus-card-sub-container js-favorite-card" data-value={this.props.favId}>
                            <ul className="list-group list-group-flush text-center">
                                <li className="list-group-item">{this.props.Title}</li>
                                <li className="list-group-item padding-top-adjustment">
                                    <div className="row justify-content-center">
                                        {this.props.recentProducts && this.props.recentProducts.map(product => {
                                                                                        
                                           
                                            return (
                                                <div role="button" className="col">
                                                    <div role="img" aria-label="favourite order thumbnail image">
                                                        <img className="fave-order-image-1" src={product.image} alt="favourite order thumbnail image" />
                                                    </div>
                                                </div>
                                            );
                                        })
                                        }
                                    </div>
                                </li>
                                <li className="list-group-item"><span className="favourite-des"> {this.props.recentProducts.map(product => { return product.name }).join(", ").trim()}  </span></li>
                                <li>
                                   {/* {<ReorderButton reOrderButton={this.props.buttonText} />}*/}
                                    {
                                        <div className="reorder-btn-container" >
                                            <a href="#" className="js-order-to-basket order-btn" role="button" data-value={this.props.basketId}><span className="order-txt" >{this.props.buttonText}</span></a>
                                        </div>
                                    }
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div role="layout" className="row">
                        <div role="layout" className="col">
                            <div role="logo" className="fave-menu-heart-logo-image"></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
